export default {
  ACCOUNT: {
    baseUrl: "account/",
    endpoints: {
      deleteAccount: "deleteAccount",
      generateSignupToken: "generateSignupToken",
      profile: `{user}`,
      users: "users",
      userEmails: "userEmails",
      uploadAvatar: "uploadAvatar"
    }
  },
  COURSE: {
    baseUrl: "course/",
    endpoints: {
      courses: "courses",
      courseIds: "courseIds",
      createCourse: "createCourse",
      deleteCourse: "deleteCourse",
      updateDescription: "updateDescription",
      addResources: "addResources",
      deleteResource: "deleteResource",
      resource: "resource/{resourceId}",
      createCategory: "createCategory",
      updateCategory: "updateCategory",
      deleteCategory: "deleteCategory"
    }
  },
  COURSE_RELATIONSHIP: {
    baseUrl: "courseRelationship/",
    endpoints: {
      courseRelationshipsForUser: "{user}",
      createCourseRelationship: "createCourseRelationship",
      updateCourseRelationship: "updateCourseRelationship",
      deleteCourseRelationship: "deleteCourseRelationship",
      setNextSessionDate: "setNextSessionDate",
      createSessionReport: "createSessionReport",
      updateSessionReport: "updateSessionReport",
      deleteSessionReport: "deleteSessionReport"
    }
  },
  EXAM: {
    baseUrl: "exams/",
    endpoints: {
      createExam: "createExam",
      updateExam: "updateExam",
      deleteExam: "deleteExam",
      setScoreTable: "setScoreTable",
      submitExam: "submitExam",
      deleteScoreReport: "deleteScoreReport"
    }
  },
  EXTERNAL: {
    baseUrl: "external/",
    endpoints: {
      createAccount: "createAccount",
      login: "login",
      requestPasswordReset: "requestPasswordReset",
      resetPassword: "resetPassword"
    }
  },
  QUESTION_BANK: {
    baseUrl: "questionBank/",
    endpoints: {
      getQuestions: "questions",
      submitQuestion: "question",
      updateQuestion: "updateQuestion",
      deleteQuestion: "deleteQuestion"
    }
  }
};
